export const formatNumberWithThreshold = (
  number: number,
  threshold: number,
): string => {
  return number > threshold ? `${threshold}+` : number.toString();
};
